import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/buttons/DrupalEntityEditButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/toolbox/ContentSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/toolbox/TaxonomySidebar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/toolbox/ToolboxDetailLayout.tsx");
